import { css } from '@emotion/react';
import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import SubjectFactList, {
	type SubjectFact,
} from '@UI/Pages/Beneficiaries/Shared/SubjectScreen/SubjectFactList';
import SubjectInformationPanel from '@UI/Pages/Beneficiaries/Shared/SubjectScreen/SubjectInformationPanel';
import FieldValueText from '@UI/Pages/Subjects/Shared/Fields/FieldValueText';
import { openEditSubjectSidebar } from '@UI/Pages/Subjects/Signals/editSubjectSidebarSignal';
import type SubjectTypeView from '@UI/Store/SubjectTypes/Views/SubjectTypeView';
import type SubjectView from '@UI/Store/Subjects/Views/SubjectView';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';

const actionsStyle = css`
	display: flex;
	gap: 0.5rem;
	flex-wrap: wrap;
`;

type Props = {
	readonly subject: SubjectView;
	readonly type: SubjectTypeView;
	readonly title: string;
};

/** The sheet of a dossier: one label and value pair per active field, and the trigger that edits it. */
const SubjectInformation: React.FC<Props> = ({ subject, type, title }) => {
	const facts = React.useMemo<readonly SubjectFact[]>(
		() =>
			type.fields.map((definition) => ({
				key: definition.key,
				label: definition.label,
				value: <FieldValueText definition={definition} values={subject.values} />,
			})),
		[type.fields, subject.values],
	);

	return (
		<SubjectInformationPanel title={title}>
			<SubjectFactList facts={facts} />
			<ConditionalLoader data={subject.canModify}>
				<div css={actionsStyle}>
					<Button
						type="button"
						severity="secondary"
						outlined
						size="sm"
						label="Modifier la fiche"
						onClick={openEditSubjectSidebar}
					/>
				</div>
			</ConditionalLoader>
		</SubjectInformationPanel>
	);
};

export default SubjectInformation;
